import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
} from '@angular/core';

@Component({
    selector: 'gl-hint',
    templateUrl: './hint.component.html',
    styleUrls: ['./hint.component.scss'],
    standalone: false
})
export class hintComponent implements OnDestroy, OnInit, OnChanges {
  @Input() public message: string;
  @Input() public mousePosition = { x: 0, y: 0 };
  @Input() public boundaryWidth;
  @Input() public boundaryHeight;
  @Input() public unit: string;
  @Input() public showUnit = true;
  @Input() public isGrey = true;
  @Input() public isNearCursor = false;

  @Output() private closeHint: EventEmitter<undefined> = new EventEmitter<undefined>();

  constructor(private elRef: ElementRef, private renderer: Renderer2) {}

  public ngOnInit(): void {
    this.setAbsolutePosition();
    this.setComponentPositionHorizontally();
    this.setComponentPositionVertically();
  }

  public ngOnChanges() {
    if (this.message) {
      this.setComponentPositionHorizontally();
      this.setComponentPositionVertically();
    }
  }

  public ngOnDestroy() {
    this.close();
  }

  public close() {
    this.closeHint.emit();
  }

  private setAbsolutePosition() {
    this.renderer.setStyle(this.elRef.nativeElement, 'position', 'absolute');
  }

  private setComponentPositionHorizontally(): void {
    const elementDimensions = this.elRef.nativeElement.getBoundingClientRect();
    const elementDimensionWidth = this.isNearCursor ? 10 : elementDimensions.width as number;
    if (this.mousePosition.x + elementDimensionWidth > this.boundaryWidth) {
      this.renderer.setStyle(
        this.elRef.nativeElement,
        'right',
        this.boundaryWidth - this.mousePosition.x + elementDimensionWidth + 'px',
      );
    } else {
      this.renderer.setStyle(this.elRef.nativeElement, 'left', this.mousePosition.x + 'px');
    }
  }

  private setComponentPositionVertically(): void {
    const elementDimensions = this.elRef.nativeElement.getBoundingClientRect();
    const elementDimensionHeight = this.isNearCursor ? 10 : elementDimensions.height as number;
    if (this.mousePosition.y + elementDimensionHeight > this.boundaryHeight) {
      this.renderer.setStyle(
        this.elRef.nativeElement,
        'bottom',
        this.boundaryHeight - this.mousePosition.y + 'px',
      );
    } else {
      this.renderer.setStyle(
        this.elRef.nativeElement,
        'top',
        this.mousePosition.y + elementDimensionHeight + 'px',
      );
    }
  }
}
